<script>
    import  { HorizontalBar }  from 'vue-chartjs';
    export default {
        extends: HorizontalBar,
        props: ['data', 'options'],
        data(){
            return {
                localOptions: {
                    legend:{
                        display: false,
                    },
                    tooltips: {
                        bodyFontSize: 16,
                        titleFontSize: 16,
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                fontStyle: 'bold',
//                                beginAtZero: true
                            }
                        }],
                        xAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    },
                    label: {
                        fontSize: 20,
                    },

                },
            };
        },
        mounted () {
            this.renderChart(this.data, this.localOptions);
        }
    };
</script>